import validator from 'validator';

export default {
	required: v => !!v || 'Campo obrigatório',
	cep: v => !v || /^\d{5}-?\d{3}/.test(v) || 'Cep inválido',
	email: v => !v || validator.isEmail(v) || 'Email inválido'
};